import jwt_decode from 'jwt-decode'
// import store from "@/store/index";

const jwt = localStorage.getItem('esep-token');

const initialState = jwt
    ? { status: { loggedIn: true }, jwt }
    : { status: { loggedIn: false }, jwt: null };

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        setToken({ commit }, jwt) {
            commit('setTokenSuccess', jwt);
        },
        refreshToken({ commit }, jwt) {
            commit('refreshTokenSuccess', jwt);
        },
        clearToken({ commit }) {
            commit('clearTokenSuccess');
        },
    },
    mutations: {
        setTokenSuccess(state, jwt) {
            localStorage.setItem('esep-token', jwt);
            state.jwt = jwt;
            state.decoded_jwt = jwt_decode(jwt);

            state.status.loggedIn = true;
            state.username = state.decoded_jwt.preferred_username;

        },
        refreshTokenSuccess(state, new_jwt) {
            localStorage.setItem('esep-token', new_jwt);
            state.jwt = new_jwt;
            state.decoded_jwt = jwt_decode(new_jwt);
        },
        clearTokenSuccess(state) {
            state.decoded_jwt = null;
            state.jwt = null;
            localStorage.removeItem('esep-token');

            state.status.loggedIn = false;
            state.username = null;

        }
    }
};